var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox-icon"},[_c('svg',{attrs:{"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"5","y":"5","width":"14","height":"14","stroke-width":"2","stroke":"#E9E9E9","rx":"4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }